import script from "./MyQueuesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyQueuesPage.vue?vue&type=script&setup=true&lang=ts"

import "./MyQueuesPage.vue?vue&type=style&index=0&id=7d5525b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5525b6"]])

export default __exports__